import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Highlighter } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function HighlightButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        return $isRangeSelection(selection) && selection.hasFormat("highlight");
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "highlight")}
            title="Highlight"
            aria-label="Highlight"
        >
            <Highlighter size={16} />
        </button>
    );
}
